import { render, staticRenderFns } from "./ArticleModalEdit.vue?vue&type=template&id=240167b5&"
import script from "./ArticleModalEdit.vue?vue&type=script&lang=js&"
export * from "./ArticleModalEdit.vue?vue&type=script&lang=js&"
import style0 from "./ArticleModalEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports